import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import templateApi from '../../../APIs/template';
import TemplateInformation from '../../../components/TechnicalTemplate/TemplateInformation';
import { Divider, NavigateBack, Typography } from '../../../designComponents';
import { RootState } from '../../../store/selectors';
import { humanReadableDateWithTime, requestAPI } from '../../../utils';
import { ViewJobContainerStyled } from '../../BrowseJobs/BrowseJobDetails/style';
// import { DownloadSymbolContainerStyled } from '../../DownloadSymbols/style';
const ViewTemplateDetails = () => {
  const { templateId } = useParams();

  const templateData = useSelector(
    (state: RootState) => state.singleTemplateData
  );

  const getTemplateData = async () => {
    try {
      await requestAPI(templateApi.getSingleTemplate(templateId || ''));
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getTemplateData();
  }, []);

  const uploadedImage = templateData.uploadTemplate?.map((data, idx) => ({
    id: `${idx}`,
    URL: data,
  }));

  return (
    <ViewJobContainerStyled>
      <div
        style={{
          backgroundColor: '#fff',
          position: 'sticky',
          zIndex: 999,
          top: '60px',
          paddingTop: '5px',
        }}
      >
        <NavigateBack />
      </div>
      <div className="contents">
        <Typography variant="title">
          Escape plan offers a diverse selection of downloadable templates for
          your use.
        </Typography>
        <Divider />
        <TemplateInformation
          templateCreateDate={humanReadableDateWithTime(
            templateData.createdAt || ''
          )}
          templateTilte={templateData.templateTitle || ''}
          country={[
            {
              name: templateData?.country?.[0] || '',
              id: templateData?._id || '',
              URL: 'https://media.istockphoto.com/id/982533982/vector/simple-flag-correct-size-proportion-colors.jpg?s=1024x1024&w=is&k=20&c=67JOZZofEraeagglFPvjdJ9EIwFXKzp0oweDgHsdlXg=',
            },
          ]}
          uploadedTemplate={uploadedImage || []}
        />
      </div>
    </ViewJobContainerStyled>
  );
};

export default ViewTemplateDetails;
